var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "align-center" }, [_vm._t("content")], 2),
    _vm._v(" "),
    _c("div", { staticClass: "align-center" }, [
      _c(
        "form",
        [
          _vm._l(_vm.steps, function (step) {
            return _c(
              "div",
              { key: step, staticClass: "space-bottom-1" },
              [
                _c(step.type === "text" ? "TextField" : step.type, {
                  tag: "component",
                  staticClass: "component-style",
                  attrs: {
                    isAnonymous: _vm.isAnonymousCustomer,
                    step: step,
                    showButton: false,
                    inputStyling: _vm.inputStyling,
                    productPrices: _vm.productPrices,
                  },
                  on: { addField: _vm.addField, clearFields: _vm.clearFields },
                  model: {
                    value: _vm.emittedFields[step.name],
                    callback: function ($$v) {
                      _vm.$set(_vm.emittedFields, step.name, $$v)
                    },
                    expression: "emittedFields[step.name]",
                  },
                }),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c("input", {
            staticClass: "field-style",
            attrs: { name: "name", value: "" },
          }),
          _vm._v(" "),
          _vm.showButton
            ? _c("ButtonSection", {
                attrs: {
                  inputValid: _vm.inputValid,
                  order: _vm.order,
                  buttonText: _vm.buttonText,
                  exitButtonText: _vm.exitButtonText,
                },
                on: {
                  "hide-modal": function ($event) {
                    return _vm.$emit("hide-modal")
                  },
                  progress: _vm.progress,
                },
              })
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }